<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Get in touch with us</h3>
        <p>We love to hear from our members. Please drop us a line if you need any help or have any comments for us. We appreciate all the input!</p>
        <!-- contact-form START here -->
        <div v-if="errors.any()" id="feedback">
          <p v-if="errors.has('name')" class="error wrong_name error-box">
            Please enter your name
          </p>
          <p v-if="errors.has('email')" class="error wrong_email error-box">
            Please enter a valid email
          </p>
          <p v-if="errors.has('message')" class="error wrong_message error-box">
            Please enter your message
          </p>
        </div>
        <form v-if="!success" id="contact_us" @submit.prevent="send">
          <p class="label_name">
            Name
          </p>
          <p class="input_form">
            <input v-model="contact.name" v-validate="'required'" type="text" name="name" data-vv-delay="1000" />
          </p>
          <p class="label_name">
            Email
          </p>
          <p class="input_form">
            <input v-model="contact.from" v-validate="'required|email'" type="email" name="email" data-vv-delay="1000" />
          </p>
          <p class="label_name">
            Message
          </p>
          <p id="textarea" class="input_form">
            <textarea id="message_input" v-model="contact.message" v-validate="'required'" name="message" rows="3" cols="4" data-vv-delay="1000"></textarea>
          </p>
          <p class="label_name"></p>
          <p class="input_form">
            <vue-recaptcha sitekey="6LcSWxkUAAAAABKb28GRtkDtDTTv6bOSJeWr4k5p" @verify="onVerify"></vue-recaptcha>
          </p>
          <p id="submit">
            <input type="submit" value="Send Message" name="submitButton" class="big-btn special" />
          </p>
        </form>
        <div v-if="success" id="success" class="success-box">
          Your message was sent succesfully! <span class="close">x</span>
        </div>

        <br />
        <br />
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="1950798677"
          ad-style="display:inline-block;width:468px;height:60px"
          ad-format="auto"
        >
        </adsense>
        <br />
        <br />
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="1950798677"
          ad-style="display:inline-block;width:468px;height:60px"
          ad-format="auto"
        >
        </adsense>
        <!-- contact-form END here -->
      </div>
      <!-- main-colum END here -->
      <!-- sidebar START here -->
      <div id="sidebar">
        <ul>
          <!-- widget START here -->
          <li class="widget">
            <div class="title">
              <h5>Contact Info</h5>
            </div>
            <div class="content">
              <div class="sprite stsblue1"></div>
              <p><strong style="text-decoration:underline;">Email:</strong> support@stumpthespread.com<br /></p>
            </div>
          </li>
          <!-- widget END here -->
          <testimonial :test="testimonial"></testimonial>
          <adsense
            ad-client="ca-pub-8213113866781504"
            ad-slot="7997332272"
            ad-style="display:inline-block;width:250px;height:250px"
            ad-format="auto"
          >
          </adsense>
        </ul>
      </div>
      <!-- sidebar END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import Adsense from '../components/adsense.vue'
import Testimonial from '../components/testimonial.vue'
import TestimonialRepository from '../data/testimonial.repository'
import ContactRepository from '../data/contact.repository'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: {
    'testimonial': Testimonial,
    'adsense': Adsense,
    'vueRecaptcha': VueRecaptcha
  },
  data () {
    return {
      testimonial: {},
      captcha: false,
      success: false,
      contact: {
        from: '',
        name: '',
        message: ''
      }
    }
  },
  created () {
    TestimonialRepository.getTestimonials(1).then(test => {
      this.testimonial = test
    })
  },
  methods: {
    send () {
      if (!this.captcha) return this.$root.$refs.toastr.e('Enter Captcha')
      this.$validator.validateAll().then(() => {
        ContactRepository.send(this.contact).then((result) => {
          this.success = true
        }).catch(() => this.$root.$refs.toastr.e('An Error has Occurred'))
      })
    },
    onVerify () {
      this.captcha = true
    }
  },
  metaInfo: {
    title: 'Contact'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Contact.vue?0360ff7d